import { apiClient,APIResponse } from './index';

export interface Policy {
  id: number;
  name: string;
  description: string;
  policytype: 'System' | 'Custom';
  severity: 'Low' | 'Medium' | 'High' | 'Critical';
  rulescount: number;
  config: Record<string, string>;
  workgroupid?: number;
  isdefault: boolean;

}

export interface CreatePolicyData {
  workgroupid: number;
  name: string;
  description: string;
  policytype: 'System' | 'Custom';
  rulescount:number;
  severity: 'Low' | 'Medium' | 'High' | 'Critical';
  config: Record<string, string>;
}

export interface UpdatePolicyData {
  name?: string;
  description?: string;
  severity?: 'Low' | 'Medium' | 'High' | 'Critical';
  standards?: Record<string, string>;
  isactive?: boolean;
}

export class PolicyAPI  {

  static async create(data: CreatePolicyData): Promise<APIResponse<Policy>> {
    return apiClient.post<Policy>('/policies', data);
  }

  static async getAll(workgroupId: number): Promise<APIResponse<Policy[]>> {
    return apiClient.get<Policy[]>(`/policies?workgroupId=${workgroupId}`);
  }

  static async delete(id: number): Promise<APIResponse<void>> {
    return apiClient.delete<void>(`/policies/${id}`);
  }

};
